
<!-- Submit and Download Buttons -->
  <div class="card mx-2">
    <div class="row mx-3 mt-4">
     <div class="d-flex justify-content-center">
      <button mat-raised-button color="primary" class="m-2 col-md-2" (click)="printDoc2()">Download Report</button>
     </div>
    </div>
  </div>
<section #content id="previewChildCaseStudyReports" class="mt-4">
  <h2 style="text-align: center">CASE STUDY REPORT</h2>
  <div class="d-flex justify-content-center gap-4" id="print-section">
    <!-- Report Data Section -->
    <table  class="m-3" style="width: 100%; border-collapse: collapse;">
      <tr *ngFor="let data of mChildData">
        <!-- First Column for Details (50%) -->
        <td style="width:60%; padding: 20px; vertical-align: top; border: 1px solid #ccc; border-radius: 8px;">
          <h3 style="text-align: left; font-weight: bold; font-size: 20px; margin-bottom: 15px;">
            Braveheart Name: {{ data.firstName }} {{ data.lastName }}
          </h3>

          <table style="width: 100%; border-collapse: collapse;">
            <tbody>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Gender</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.gender }}</td>
            </tr>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Age</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.age }}</td>
            </tr>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">City</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.city }}</td>
            </tr>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">State</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.state }}</td>
            </tr>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Diagnosis</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.diagnosis }}</td>
            </tr>
            <tr>
              <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Hospital</th>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ data.hospital }}</td>
            </tr>
            </tbody>
          </table>
        </td>

        <!-- Second Column for Image (50%) -->
        <td style="width: 40%; padding: 20px; vertical-align: top; border: 1px solid #ccc; border-radius: 8px; text-align: center;">
          <img [src]="data.admissionDocuments" class="img-fluid" alt="Child Image" style="height: 260px; width:190px; object-fit: cover; border: 2px solid;" >
        </td>
      </tr>
    </table>
  <!-- Narrative Text Section -->
  </div>
  <div style="display: flex; justify-content: center; margin-top: 16px;">
    <p style="text-align: justify; text-justify: inter-word; padding: 10px" [innerHTML]="narrative">
      {{narrative }}
    </p>
  </div>


</section>
